import React from 'react';
// import landingVideo from 'https://ligasos.co/vedio/0_Cityscape_Night_3840x2160.mp4';
import { useNavigate } from "react-router-dom";
import propertiesSectionData from "../data/propertiesSectionData";
import { useState } from 'react';
import { useTranslation } from "react-i18next";
const LandingPage = () => {

  const { t } = useTranslation();

  const [selectedCountry, setSelectedCountry] = useState("");
  const [selectedPlace, setSelectedPlace] = useState("");
  const navigate = useNavigate();

  const uniqueCountries = [...new Set(propertiesSectionData.map((item) => item.countries))];

  const filteredPlaces =
    selectedCountry !== ""
      ? propertiesSectionData
        .filter((item) => item.countries === selectedCountry)
        .map((item) => ({ id: item.id, placeName: item.placeName }))
      : [];

  const handleSearch = () => {
    if (selectedPlace) {
      navigate(`/landDetailes/${selectedPlace}`);
    } else {
      alert("Please select a place.");
    }
  };
  return (
    <div className="relative h-[97vh] w-full overflow-hidden">
      <video
        autoPlay
        loop
        muted
        className="absolute top-0 left-0 w-full h-full object-cover"
      >
        <source src="https://ligasos.co/vedio/0_Cityscape_Night_3840x2160.mp4" type="video/mp4" />
      </video>

      <div className="absolute top-0 left-0 w-full h-full bg-black opacity-50"></div>

      <div className="px-res px-[150px] relative z-10 flex flex-col justify-center h-[107vh] text-white">
        <div className="text-center flex flex-col justify-center gap-[20px] max-w-3xl">
          <h1 className="text-st-ar btmAni2000 text-left text-5xl md:text-6xl mb-6 animate-fade-in-down leading-[1.2] font-extrabold font-f">
            {t("Find your home with Ligasos.")}
          </h1>
          <div className='f-col flex items-center gap-[15px]'>
            <div className="btmAni2500 f-col flex items-center gap-4 w-full  mx-auto bg-white  w-full rounded-[4px]">
              <select
                className="w-full px-4 py-[10px] text-sm font-medium text-gray-700 bg-white rounded-[4px] shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                value={selectedCountry}
                onChange={(e) => {
                  setSelectedCountry(e.target.value);
                  setSelectedPlace("");
                }}
                aria-label="Select Country"
              >
                <option value="" disabled>
                  {t("Select Country")}
                </option>
                {uniqueCountries.map((country, index) => (
                  <option key={index} value={country}>
                    {t(`${country}`)}
                  </option>
                ))}
              </select>
              <select
                className={`w-full px-4 py-[10px] text-sm font-medium ${selectedCountry ? "bg-white" : "bg-gray-100 cursor-not-allowed"
                  } text-gray-700 rounded-[4px] shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent`}
                value={selectedPlace}
                onChange={(e) => setSelectedPlace(e.target.value)}
                disabled={!selectedCountry}
                aria-label="Select Place"
              >
                <option value="" disabled>
                  {t("Select Place")}
                </option>
                {filteredPlaces.map((place) => (
                  <option key={place.id} value={place.id}>
                    {t(`${place.placeName}`)}
                  </option>
                ))}
              </select>
            </div>
            <button
              className="btmAni2500 w-100 px-6 py-2 text-sm font-semibold text-white bg-gradient-to-r from-blue-600 to-blue-700 rounded-[4px] shadow-md hover:from-blue-700 hover:to-blue-800 transition duration-300 ease-in-out transform hover:scale-105 active:scale-95 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2"
              onClick={handleSearch}
              aria-label="Search"
            >
              {t("Search")}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LandingPage;